import { InjectionToken } from '@angular/core';

export const RESOURCE_TOKEN = new InjectionToken('resource');
export const WAZARIAPP_TOKEN = new InjectionToken('wazariApp');
